import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getRefererWhitelabelIcon } from "../../api/quote";

const WhitelabelWrapper = ({
  children,
  iconLink,
  whitelabelCompanyName,
  whitelabelHeadline,
}) => {
  const [refererIcon, setRefererIcon] = useState(null);
  useEffect(() => {
    const fetchRefererIcon = async () => {
      try {
        const icon = await getRefererWhitelabelIcon();
        setRefererIcon(URL.createObjectURL(icon));
        updateFavIcon(URL.createObjectURL(icon));
      } catch (error) {
        console.warn("Failed to fetch referer icon: " + error?.statusText);
      }
    };

    fetchRefererIcon();
  }, []);

  useEffect(() => {
    if (whitelabelCompanyName) {
      document.title = whitelabelCompanyName;
    }
  }, [whitelabelCompanyName]);

  const updateFavIcon = (iconUrl) => {
    if (!iconUrl) {
      console.warn("Invalid icon URL provided.");
      return;
    }

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = iconUrl;
  };

  return (
    <div className="flex h-screen w-full flex-col font-fontFamily">
      <header className="flex h-16 w-full items-center justify-between bg-primaryColor p-4 md:h-24 lg:h-28 lg:p-10 xl:h-32">
        <a href={iconLink}>
          <img
            src={refererIcon}
            alt="logo"
            className="h-12 object-contain lg:h-20 xl:h-24"
          />
        </a>
        <h2 className="w-1/2 text-wrap text-xs text-secondaryColor md:text-base lg:w-1/3 lg:text-xl xl:w-1/4">
          {whitelabelHeadline}
        </h2>
      </header>
      <main className="flex-1 bg-backgroundColor">{children}</main>
    </div>
  );
};

WhitelabelWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  iconLink: PropTypes.string,
  whitelabelCompanyName: PropTypes.string,
  whitelabelHeadline: PropTypes.string,
};

export default WhitelabelWrapper;
